import React, { Component } from "react";

import Layout from "../header_footer/Layout";

import Jumbotron from "../utils/Jumbotron";

import RestauranteSmall from "../utils/EspacosSmall/EspacoSmall";

import PropTypes from 'prop-types';

import axios from "axios";

import Masonry from 'react-masonry-component';


class Restaurantes extends Component {

  static contextTypes = {
    router: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props);

    this.state = {
      restaurantes: []
    };
  }

  componentDidMount = () => {
    this.loadRestaurantes();
  };

  loadRestaurantes = async () => {
    
   let res = {};
   try {
     res = await axios.get("/api/restaurantes", {
       params: {},
       headers: {
         APIKEY: "q7tXDJZX1StZAKZsKTLu5FRBs5k42vSf",
         "Content-Type": "application/json"
       }
     });
   } catch (error) {
     console.log(error);
   }

   let restaurantes = res.data.arrayRestaurantes;

    this.setState({ restaurantes });
  };

  restauranteClicked = (identifier) => {
    this.context.router.history.push("/restaurantes/" + identifier);
  }
  

  render() {

    return (
      <Layout>
        <Jumbotron title={"Restaurantes"}></Jumbotron>

        <div className="container">
          

            <Masonry
              className={"row"}
              elementType={"div"}
              options={{transitionDuration: 0}}
            >

              {
                this.state.restaurantes.map(function(item) {
                  return <RestauranteSmall entityClicked={this.restauranteClicked} item={item} key={item.name}></RestauranteSmall>
                }.bind(this))
              }

            </Masonry>

          
        </div>


      </Layout>
    );
  }
}

export default Restaurantes;
